type HeaderProps = {
  text: string;
};
export const IntegrationHeader = ({ text }: HeaderProps): JSX.Element => {
  return <div className="pb-4 text-xl font-bold font-black">{text}</div>;
};
